/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as pxp from './PXPApp'
import { componentApi, loadTranslations } from 'common'


export class LaunchPadEditor {
  async Init() : Promise<any> {
    return await componentApi.call('pxp', 'launch-pad-editor', 'LaunchPadEditor', 'Init', {
    });
  }
  async SaveLaunchPadDefinition(def : pxp.LaunchPadDefinition) : Promise<pxp.LaunchPadDefinition> {
    return await componentApi.call('pxp', 'launch-pad-editor', 'LaunchPadEditor', 'SaveLaunchPadDefinition', {
      def,
    });
  }
  async GetMissingModules(launchPadGU : string, userType : pxp.UserType) : Promise<Array<pxp.ModuleConfigInfo>> {
    return await componentApi.call('pxp', 'launch-pad-editor', 'LaunchPadEditor', 'GetMissingModules', {
      launchPadGU,
      userType,
    });
  }
  async GetPXPModules(userType : pxp.UserType) : Promise<Array<pxp.ModuleConfigInfo>> {
    return await componentApi.call('pxp', 'launch-pad-editor', 'LaunchPadEditor', 'GetPXPModules', {
      userType,
    });
  }
  async GetPXPModuleDefs() : Promise<Array<pxp.PXPModuleDef>> {
    return await componentApi.call('pxp', 'launch-pad-editor', 'LaunchPadEditor', 'GetPXPModuleDefs', {
    });
  }
  async GetConfiguration(launchPadGU : string) : Promise<any> {
    return await componentApi.call('pxp', 'launch-pad-editor', 'LaunchPadEditor', 'GetConfiguration', {
      launchPadGU,
    });
  }
  async GetOLRModuleDefs() : Promise<Array<pxp.PXPModuleDef>> {
    return await componentApi.call('pxp', 'launch-pad-editor', 'LaunchPadEditor', 'GetOLRModuleDefs', {
    });
  }
  async GetANAModuleDefs(userType : pxp.UserType) : Promise<Array<pxp.PXPModuleDef>> {
    return await componentApi.call('pxp', 'launch-pad-editor', 'LaunchPadEditor', 'GetANAModuleDefs', {
      userType,
    });
  }
  async GetSecurityOptions() : Promise<any> {
    return await componentApi.call('pxp', 'launch-pad-editor', 'LaunchPadEditor', 'GetSecurityOptions', {
    });
  }
  async GetLaunchUrl(url : string, agu : string) : Promise<string> {
    return await componentApi.call('pxp', 'launch-pad-editor', 'LaunchPadEditor', 'GetLaunchUrl', {
      url,
      agu,
    });
  }
  async GetLaunchPadDefinition(launchPadGU : string) : Promise<pxp.LaunchPadDefinition> {
    return await componentApi.call('pxp', 'launch-pad-editor', 'LaunchPadEditor', 'GetLaunchPadDefinition', {
      launchPadGU,
    });
  }
}
export default new LaunchPadEditor()
